import application_settings from '../applicationSettings';
import Event from './Event';

class UserRegister extends Event {
    eventName = 'oms_userRegister';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for User Register
     * 
     * @param {string} data.name -  name of the customer
     * @param {string} data.email -  email of the customer
     * @param {string} data.calling_code -  calling code of the customer
     * @param {string} data.contact_number -  contact number of the customer
     * @param {string} data.password -  password of the customer
     * @param {string} data.confirm_password -  confirm password of the customer
     * @param {string} data.more_info -  more info (custom fields) of the customer
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.userRegister;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            name: data.name,
            email: data.email,
            calling_code: data.calling_code,
            contact_number: data.contact_number,
            password: data.password,
            confirm_password: data.confirm_password,
            more_info: JSON.stringify(data.more_info)
        };

        // send request
        this.sendRequest(data, function (response) {
          if (response) {
            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });

    }
}

export default UserRegister;